import { useServiceProvider } from '../Providers';
import useContentWidth from './useContentWidth';

const NETWORK_4G = '4g';
const NETWORK_3G = '3g';

export default function useTourImageWidth() {
  const { connectionService } = useServiceProvider();
  const networkType = connectionService.networkType ?? NETWORK_4G;

  const width = useContentWidth(networkType === NETWORK_4G);
  if ([NETWORK_3G, NETWORK_4G].includes(networkType)) {
    return width;
  } else {
    return Math.floor(width / 2);
  }
}
